import App from "../controllers/App/App";
import { HeroBanner } from "colbi_web_ui/lib/components";
import FileMessageSalesSubmissionInformation from "../components/FileMessageSalesSubmissionInformation/FileMessageSalesSubmissionInformation";
import { Task } from "mosaic-react-icons";
import { MultipleDownloadButton } from "../components/MultipleDownloadButton/MultipleDownloadButton";
const queries = (args = {}) => {
    return args.fiscalYear
        ? [
              {
                  //to defer old core of the new core -> full old core navigation
                  resource: "nc_audit_summary",
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      importId: args.importId,
                      modulePrefix: args.modulePrefix,
                  },
                  body: "severity, count",
              },
              {
                  resource: "generic_overview",
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      importId: args.importId,
                      modulePrefix: args.modulePrefix,
                      locale: args.locale,
                  },
              },
              {
                  resource: "generic_overview_export",
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      importId: args.importId,
                      modulePrefix: args.modulePrefix,
                  },
                  body: "report",
                  downloadable: true,
                  downloadOnly: true,
                  xlsxTranslation: "overview",
              },
              {
                  resource: "submission_files_repository",
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      importId: args.importId,
                      modulePrefix: args.modulePrefix,
                  },
                  body: "status, files, fileType",
              },
          ]
        : [];
};

const genericOverview = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: App,
    queries,
    exact,
    navByImportId,
    title: [title],
    headerComponentConfigs: {
        showButton: true,
        label: "Download",
        items: [{ menuLabel: "Excel" }],
    },
    headerComponents: [{ component: MultipleDownloadButton }],
    isOverview: true,
    components: [
        {
            component: FileMessageSalesSubmissionInformation,
            props: {
                mergeRepository: "query(3)",
            },
        },
        {
            component: HeroBanner,
            modifiers: ["--root-margin-bottom-normal"],
            props: {
                icon: Task,
                title: "label(Audit Results)",
                summary: "query(0).list",
                link: {
                    to: `/:projectId/:fiscalYear/:importId/nc_audit`,
                    name: "label(View all)",
                    createLink: true,
                },
                overviewSummaryWidget: true,
            },
        },
    ],
});

export default genericOverview;
